import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

const LocationsTypeahead = ({
    isRequired,
    isClearable,
    error,
    labelId = 'location',
    isMulti,
    animatedPlaceholder,
    backspaceRemovesValue,
    suggestions = [],
    value,
    onChangeSuggestion,
    renderMultiSuggestion: renderSuggestion = renderMultiSuggestion
}) => {
    const options = suggestions.map(location => ({
        label: location.name,
        value: location.id
    }));

    return (
        <MultiTypeahead
            isClearable={isClearable}
            isRequired={isRequired}
            error={error}
            titleId={labelId}
            isMulti={isMulti}
            animatedPlaceholder={animatedPlaceholder}
            backspaceRemovesValue={backspaceRemovesValue}
            options={options}
            value={value}
            onChangeSuggestion={onChangeSuggestion}
            formatOptionLabel={renderSuggestion}
        />
    );
};

LocationsTypeahead.propTypes = {
    labelId: PropTypes.string,
    suggestions: PropTypes.array,
    error: PropTypes.string,
    onChangeSuggestion: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    isMulti: PropTypes.bool,
    isRequired: PropTypes.bool,
    isClearable: PropTypes.bool,
    animatedPlaceholder: PropTypes.bool,
    backspaceRemovesValue: PropTypes.bool,
    renderMultiSuggestion: PropTypes.func
};

const mapStateToProps = ({ infrastructure }) => ({
    suggestions: infrastructure.locations || []
});

export default connect(mapStateToProps)(LocationsTypeahead);
